// extracted by mini-css-extract-plugin
module.exports = {"root":"page-loader_root__3rtjL","content":"page-loader_content__3Rk6o"};